import { render, staticRenderFns } from "./motorcade.vue?vue&type=template&id=08fd8f94&scoped=true&"
import script from "./motorcade.vue?vue&type=script&lang=js&"
export * from "./motorcade.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=08fd8f94&lang=scss&scoped=true&"
import style1 from "./motorcade.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fd8f94",
  null
  
)

export default component.exports